/** Placement group a nav entity belongs to — which surface/hook owns it. */
export enum NavGroup {
    TopNav = 'TOP_NAV',
    LeftNav = 'LEFT_NAV',
    QuickLink = 'QUICK_LINK',
    Dropdown = 'DROPDOWN'
}

/** Which presentational component renders a nav item. */
export enum NavItemType {
    CustomerName = 'customerName',
    Cobuyer = 'cobuyer',
    AddCobuyer = 'addCobuyer',
    Inbox = 'inbox',
    SendToDesk = 'sendToDesk',
    ShareDropdown = 'shareDropdown',
    DealComments = 'dealComments',
    Card = 'card',
    Link = 'link'
}
